module.exports = __webpack_public_path__ + "img/wszb.264d0a8b.png";